export default __webpack_public_path__ + "static/media/web.68e110f3.png";